// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-head-info[data-v-7e587b6c] {\n  display: flex;\n  font-size: 13px;\n}\n.table-head-info .name[data-v-7e587b6c] {\n  color: #333;\n  padding-right: 20px;\n}\n.table-head-info .text[data-v-7e587b6c] {\n  color: #666;\n}", ""]);
// Exports
module.exports = exports;
